import { ArrowRight, Check, CircleCheck } from "lucide-react";
import React, { SetStateAction } from "react";

interface JobRequirementCardProps {
  data: any;
  importedRequirementDetails: any;
  setImportedRequirementDetails: React.Dispatch<SetStateAction<any>>;
  selectedRequirement: any;
  setSelectedRequirement: React.Dispatch<SetStateAction<any>>;
}

const JobRequirementCard = ({
  data,
  importedRequirementDetails,
  setImportedRequirementDetails,
  selectedRequirement,
  setSelectedRequirement,
}: JobRequirementCardProps) => {
  const isSelected = selectedRequirement?._id === data?._id;
  const isRequirementImported = importedRequirementDetails?._id === data?._id;

  return (
    <button
      onClick={() => setSelectedRequirement(data)}
      className="flex flex-col"
    >
      <div className="bg-gray-50 p-4">
        <div
          className={`flex items-center justify-between bg-white ${isSelected ? "border border-black" : "border"} rounded-md p-4`}
        >
          <div className="flex items-center gap-3.5">
            <div className="rounded-md bg-charcoal h-10 w-10 flex items-center justify-center text-white font-semibold text-xl">
              {data?.title?.charAt(0)}
            </div>
            <div className="flex flex-col items-start">
              <span className="text-xsss font-medium text-gray-400">
                {data?.refNo} · Received 06 Aug 2026
              </span>
              <span className="font-semibold text-sm">{data?.title}</span>
              <span className="text-xsss font-medium text-light-black">
                {data?.company?.name} · Permanent · {data?.city} hybrid
              </span>
            </div>
          </div>

          <div className="flex items-center gap-2 border-l pl-4">
            <div className="flex flex-col items-center gap-1">
              <div className="rounded-full text-xss font-semibold text-green-800 bg-green-100 w-max px-2 py-0.5">
                Approved to recruit
              </div>
              <span className="text-xsss font-medium text-light-black">
                {data?.skills?.length} skill requirements
              </span>
            </div>

            {isSelected ? (
              <CircleCheck
                size={22}
                strokeWidth={1.5}
                fill="#475569"
                stroke="white"
              />
            ) : null}
          </div>
        </div>
      </div>

      {selectedRequirement && isSelected ? (
        <div className="">
          <div className="grid grid-cols-[1.2fr_0.8fr] border-t p-4">
            <span className="text-xss font-medium text-light-black text-left">
              <span className="font-bold">Included</span> Role facts,
              hiring-company comments, job description draft and contextual
              skill requirements.
            </span>
            <button
              onClick={() => setImportedRequirementDetails(data)}
              className="bg-black rounded-md flex items-center text-xss font-semibold text-white h-8 gap-4 px-3 hover:bg-black/85 w-max ml-auto"
            >
              {isRequirementImported
                ? "Requirement imported"
                : "Import requirement details"}
              {isRequirementImported ? (
                <Check color="white" size={14} />
              ) : (
                <ArrowRight size={14} color="white" />
              )}
            </button>
          </div>

          {isRequirementImported ? (
            <div className="flex items-center bg-green-100 border-t px-4 py-2.5 gap-3">
              <CircleCheck
                size={24}
                fill="#239447"
                stroke="white"
                strokeWidth={1.5}
              />
              <div className="flex flex-col items-start">
                <span className="text-xs font-semibold">
                  Requirement details imported
                </span>
                <span className="text-xss font-medium text-light-black">
                  The source reference remains attached to this draft for review
                  and audit context.
                </span>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </button>
  );
};

export default JobRequirementCard;
